import { AssignmentQuestionsWorkedOn } from "./assignment_questions-worked-on"

export class TeacherUsageStats {
  constructor(
    public userId: string,
    public firstName: string,
    public lastName: string,
    public displayName: string,
    public isPro: boolean,
    public lastLogin: Date | undefined,
    public assignmentCount: number | undefined,
    public assignmentsWorkedOnThisYear: number | undefined,
    public assignmentQuestionsWorkedOn:
      | AssignmentQuestionsWorkedOn
      | undefined
      | null,
  ) {}

  get pagesWorkedOnThisYear(): number | undefined {
    if (!this.assignmentQuestionsWorkedOn) return
    return this.assignmentQuestionsWorkedOn["thisYear"]
  }

  get pagesWorkedOnThisMonth(): number | undefined {
    if (!this.assignmentQuestionsWorkedOn) return
    return this.assignmentQuestionsWorkedOn["thisMonth"]
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }
}
